import { render, staticRenderFns } from "./team-index.vue?vue&type=template&id=784ab9f2&scoped=true"
import script from "./team-index.vue?vue&type=script&lang=js"
export * from "./team-index.vue?vue&type=script&lang=js"
import style0 from "./team-index.vue?vue&type=style&index=0&id=784ab9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ab9f2",
  null
  
)

export default component.exports